"use client"

// import * as React from "react"
import { format } from "date-fns/format";
import { id } from 'date-fns/locale/id';
import { IoCalendarOutline } from "react-icons/io5";

import { Button } from "../ui/button"
import { Calendar } from "../ui/calendar"
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "../ui/popover"
import { DateRange } from "react-day-picker"
import { useState } from "react";
import {isBefore} from "date-fns/isBefore"
import {isSameDay} from "date-fns/isSameDay"

type PropsType = SingleProps | MultipleProps | RangeProps;

type SingleProps = {
  mode: "single";
  value?: Date;
  onChange?: (date: Date | undefined) => void;
  disabled: boolean;
  minDate?: Date;
};

type MultipleProps = {
  mode: "multiple";
  value?: Date[];
  onChange?: (date: Date[] | undefined) => void;
  disabled: boolean;
  minDate?: Date;
};

type RangeProps = {
  mode: "range";
  value?: DateRange;
  onChange?: (date: DateRange | undefined) => void;
  disabled: boolean;
  minDate?: Date;
};

export function DatePicker({
  mode,
  value,
  onChange,
  disabled,
  minDate,
}: PropsType) {
  
  const [open, setOpen] = useState(false);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          disabled={disabled}
          variant="outline"
          data-empty={!value}
          className="w-full rounded-lg justify-start text-left font-normal data-[empty=true]:text-muted-foreground text-black disabled:bg-neutral-300 h-[38px]"
        >
          <IoCalendarOutline />
          {value ? format(value as any, 'dd MMMM yyyy', { locale: id }) : <span>Pilih tanggal</span>}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0 bg-white shadow-xl border border-neutral-300 mt-1" align="start">
        <Calendar
          locale={id}
          mode={mode as any}
          selected={value as any}
          onSelect={(d: any) => {
            (onChange as any)?.(d);
            setOpen(false);
          }}
          defaultMonth={value instanceof Date ? value : new Date()}
          // disabled={disabled}
          disabled={(date) => disabled || (minDate ? isBefore(date, minDate) && !isSameDay(date, minDate) : false)}
          modifiersClassNames={{
            selected: "bg-sky-500 text-white rounded-full"
          }}
        />
      </PopoverContent>
    </Popover>
  )
}
